import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Rect,
          {
            width: "20",
            height: "14",
            x: "2",
            y: "3",
            rx: "2",
            ry: "2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Line, { x1: "8", x2: "16", y1: "21", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "17", y2: "21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 13V7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m15 10-3 3-3-3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "MonitorDown";
const MonitorDown = memo(themed(Icon));
export {
  MonitorDown
};
//# sourceMappingURL=monitor-down.js.map
